import { Row, Col, Container } from 'react-bootstrap'; 
import TypeAnimation from 'react-type-animation';
import Sparkle from 'react-sparkle'


export default function Landing() {
    return (
        <Row id="landing">
           <Container className="mt-1 mb-3">
           <Col className="p-5 mt-1 mb-3"  xs={12} md={12} lg={12}>
            <img id="avatar" src="/avatar.png" alt="not found"/>
                <Sparkle 
                	color={['#FFF','#FCF69C','#FF6FB5','#AB46D2']}
                	minSize={5}
  					maxSize={15}
  					overflowPx={80}
  					count={50}
  					newSparkleOnFadeOut={true}
                />
                <TypeAnimation
			      cursor={false}
			      sequence={[ 
			      	 'Martin Miguel', 1000, 
			      	 'Graphic Designer', 1000, 
			      	 'Frontend Web Developer', 1000, 
			      	 'Backend Web Developer', 1000, 
			      	 'Licensed Teacher', 1000, 
			      	 'Full Stack Web Developer', 1000]}
			      wrapper="p"
			      repeat={Infinity}
			      className="dev-name mt-1 mb-5"
				/>
                
            </Col>
            </Container>
         </Row>
      );
};